import { useEffect, useRef, useState } from "react";

import { api, type BilanImport, type Classe } from "./api";

const FORMATS: Record<string, string> = {
  A: "macros exo7",
  B: "questions numérotées",
  C: "boîtes titrées",
  D: "liste plate",
};

export default function ImportDs({ surImport }: { surImport: () => void }) {
  const [classes, setClasses] = useState<Classe[]>([]);
  const [classeId, setClasseId] = useState<number | null>(null);
  const [date, setDate] = useState("");
  const [bilan, setBilan] = useState<BilanImport | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);
  const [encours, setEncours] = useState(false);
  const fichier = useRef<HTMLInputElement>(null);

  useEffect(() => {
    api.listerClasses().then((liste) => {
      setClasses(liste);
      if (liste.length > 0) setClasseId(liste[0].id);
    });
  }, []);

  const importer = async (choisi: File) => {
    if (classeId === null) return;
    setEncours(true);
    setErreur(null);
    setBilan(null);
    try {
      setBilan(await api.importerDs(classeId, choisi, date));
      surImport();
    } catch (e) {
      setErreur((e as Error).message);
    } finally {
      setEncours(false);
    }
  };

  if (classes.length === 0) {
    return (
      <p className="aide">
        Créez d'abord une classe dans l'onglet <strong>Classes</strong> : un devoir
        s'y rattache.
      </p>
    );
  }

  return (
    <div className="import-ds">
      <h3>Importer un énoncé</h3>
      <div className="actions">
        <select
          value={classeId ?? ""}
          onChange={(e) => setClasseId(Number(e.target.value))}
        >
          {classes.map((classe) => (
            <option key={classe.id} value={classe.id}>
              {classe.code} — {classe.niveau_libelle}
            </option>
          ))}
        </select>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          title="Date du devoir (facultative)"
        />
        <input
          ref={fichier}
          type="file"
          accept=".tex,text/x-tex,text/plain"
          hidden
          onChange={(e) => {
            const choisi = e.target.files?.[0];
            if (choisi) importer(choisi);
            e.target.value = "";
          }}
        />
        <button
          type="button"
          onClick={() => fichier.current?.click()}
          disabled={encours}
        >
          {encours ? "Analyse en cours…" : "Choisir un fichier .tex"}
        </button>
      </div>

      {erreur && <p className="erreur">{erreur}</p>}

      {bilan && (
        <p className="message">
          <strong>{bilan.titre ?? "Sans titre"}</strong> importé :{" "}
          {bilan.exercices} exercices, {bilan.questions} questions
          {bilan.bonus > 0 && ` dont ${bilan.bonus} bonus`}, barème de départ{" "}
          {bilan.total_points} pts (1 pt par question, à ajuster).
          {" "}Format reconnu : {FORMATS[bilan.format] ?? bilan.format}.
        </p>
      )}
    </div>
  );
}
